import React, { useEffect, useState } from "react";
import {
  FaCar,
  FaMoneyBillWave,
  FaTags,
  FaWallet,
  FaMobileAlt,
  FaCreditCard,
  FaRegQuestionCircle,
  FaArrowRight,
} from "react-icons/fa";
import { RiMoneyRupeeCircleFill } from "react-icons/ri";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { Card, Col, Spinner } from "react-bootstrap";
import verify from "../../Images/verify.png";
import { FaCheckCircle, FaTimesCircle, FaAdjust } from "react-icons/fa";
import { BiSolidDiscount } from "react-icons/bi";
import Select from "react-select";
import { toast } from "react-toastify";
import { FaRegCheckCircle } from "react-icons/fa";
import { MdOutlineClose, MdRunningWithErrors } from "react-icons/md";
import {
  createBillApi,
  verifyVehicleNumberApi,
} from "../../services/BillingService";
import { Box, Paper, Skeleton } from "@mui/material";
import {
  getBrandModelApi,
  getServiceoption,
  getVehicleNumberApi,
  getVehicleTypeUsingModel,
} from "../../services/SearchService";
import { FaCarSide, FaTruckPickup, FaMotorcycle } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  IconButton,
  Button,
} from "@mui/material";
import { IoClose } from "react-icons/io5";

const paymentTypes = [
  {
    key: "UPI BUSINESS",
    label: "UPI Business",
    icon: <FaMobileAlt size={13} />,
  },
  {
    key: "UPI PERSONAL",
    label: "UPI Personal",
    icon: <FaMobileAlt size={13} />,
  },
  { key: "CASH", label: "Cash", icon: <FaMoneyBillWave size={13} /> },
  { key: "CARD", label: "Card", icon: <FaCreditCard size={13} /> },
];

export const vehicleTypeIcons = {
  "Small Car": <FaCarSide className="ms-2" size="30" />,
  "Medium Car": <FaCar className="ms-2" size="30" />,
  "Large Car": <FaTruckPickup className="ms-2" size="30" />,
  "Premium Car": <FaCar className="ms-2" size="30" />,
  Bike: <FaMotorcycle className="ms-2" size="30" />,
  "Premium Bike": <FaMotorcycle className="ms-2" size="30" />,
};

const VehicleTypeBadge = ({ vehicleType, image }) => {
  const [imageModal, setImageModal] = useState(false);
  const handletoggleImageModal = () => {
    setImageModal(!imageModal);
  };
  return (
    <>
      <span
        className="d-flex gap-2 align-items-center ps-1 pe-2 py-1 rounded-3 border border-warning text-bg-warning-soft cursor-pointer"
        onClick={image ? () => handletoggleImageModal() : undefined}
        style={{
          background: "#f8f9fa",
          fontWeight: "600",
          fontSize: "0.9rem",
          color: "#343a40",
          boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        {image ? (
          <img
            src={`${process.env.REACT_APP_BASE_URL}${image}`}
            alt={vehicleType}
            style={{
              width: "36px",
              height: "31px",
              borderRadius: "23%",
              objectFit: "cover",
            }}
          />
        ) : (
          <span>{vehicleTypeIcons[vehicleType]}</span>
        )}
        <span>{vehicleType}</span>
        {vehicleType && (
          <img src={verify} alt="verified" height="15px" width="15px" />
        )}
      </span>

      <Dialog
        open={imageModal}
        onClose={handletoggleImageModal}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "12px" },
        }}
      >
        <DialogTitle
          className="d-flex justify-content-between align-items-center border-bottom"
          sx={{ p: 2, pb: 1 }}
        >
          <span className="fw-medium" style={{ fontSize: "1.1rem" }}>
            {vehicleType}
          </span>

          <IconButton onClick={handletoggleImageModal} size="small">
            <IoClose size={20} />
          </IconButton>
        </DialogTitle>
        <Divider />

        <DialogContent className="p-0 text-center">
          <img
            src={`${process.env.REACT_APP_BASE_URL}${image}`}
            alt={vehicleType}
            style={{
              maxHeight: "400px",
              maxWidth: "100%",
              objectFit: "contain",
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

const BillingAdd = () => {
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [createLoading, setCreateLoading] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [modelOption, setModelOption] = useState([]);
  const [vehicleNumberOption, setVehicleNumberOption] = useState([]);
  const [serviceConfirmation, setServiceConfirmation] = useState(false);
  // Override dialog states
  const [overrideDialogOpen, setOverrideDialogOpen] = useState(false);
  const [overrideFields, setOverrideFields] = useState({});
  const [selectedOverrides, setSelectedOverrides] = useState({});

  const [currentVehicle, setCurrentVehicle] = useState({
    paymentStatus: "",
    paymentMethod: "",
    partialAmount: "",
    customerName: "",
    customerMobile: "",
    selectedModel: null,
    model_image: null,
    vehicleNumber: "",
    vehicleType: "",
    isVerify: false,
    serviceOption: [],
    selectedService: [],
    discount: "",
    tipAmount: "",
    remarks: "",
    date: new Date().toISOString().split("T")[0] || "",
    is_free_service: false,
    verifyLoading: false,
  });

  const handleConfirmFreeService = () => {
    setCurrentVehicle((prev) => ({
      ...prev,
      is_free_service: true,
      paymentStatus: "UNPAID",
      paymentMethod: "",
      partialAmount: "",
      discount: "",
      tipAmount: "",
      remark: "",
    }));
    setServiceConfirmation(false);
  };

  const handleCancelFreeService = () => {
    setServiceConfirmation(false);
  };

  const verifyVehicle = (number) => {
    setCurrentVehicle((prev) => ({
      ...prev,
      verifyLoading: true,
      isVerify: false,
    }));

    verifyVehicleNumberApi(number)
      .then((res) => {
        const data = res?.data?.results[0];
        const model = modelOption?.find(
          (item) => item?.value == data?.vehicle_model
        );

        const apiData = {
          customerName: data?.customer_name || "",
          customerMobile: data?.customer_contact || "",
          vehicleType: data?.vehicle_type || "",
          model_image: data?.vehicle_model_image || "",
          selectedModel: model || null,
        };

        const filledFields = Object.keys(apiData).filter(
          (key) => currentVehicle[key]
        );

        if (filledFields.length > 0) {
          setOverrideFields(apiData);
          const defaults = {};
          Object.keys(apiData).forEach((key) => {
            defaults[key] = !currentVehicle[key];
          });
          setSelectedOverrides(defaults);
          setOverrideDialogOpen(true);
        } else {
          // Direct autofill
          setCurrentVehicle((prev) => ({
            ...prev,
            ...apiData,
            isVerify: true,
            verifyLoading: false,
          }));

          // if (model) {
          //   getVehicleTypeByModel(model);
          // }
        }
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setCurrentVehicle((prev) => ({ ...prev, verifyLoading: false }));
      });
  };

  const handleCheckboxChange = (field) => {
    setSelectedOverrides((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSelectAll = (checked) => {
    const all = {};
    Object.keys(overrideFields).forEach((key) => {
      all[key] = checked;
    });
    setSelectedOverrides(all);
  };

  const handleOverrideConfirm = () => {
    const updatedData = {};
    Object.keys(selectedOverrides).forEach((key) => {
      if (key == "selectedModel" && selectedOverrides?.selectedModel) {
        updatedData.model_image = overrideFields?.model_image || null;
        updatedData.vehicleType = overrideFields?.vehicleType || "";
        updatedData.selectedModel = overrideFields?.selectedModel || null;
      } else if (
        key == "selectedModel" &&
        !selectedOverrides?.selectedModel &&
        selectedOverrides?.model_image &&
        selectedOverrides?.vehicleType
      ) {
        updatedData.model_image = null;
        updatedData.vehicleType = "";
        updatedData.selectedModel = null;
      } else if (selectedOverrides[key]) {
        updatedData[key] = overrideFields[key];
      }
    });

    setCurrentVehicle((prev) => ({
      ...prev,
      ...updatedData,
      isVerify: true,
      verifyLoading: false,
    }));

    // if (selectedOverrides["selectedModel"] && overrideFields?.selectedModel) {
    //   getVehicleTypeByModel(overrideFields.selectedModel);
    // }

    setOverrideDialogOpen(false);
  };

  const handleChangVehicleNumber = (value) => {
    setCurrentVehicle({
      ...currentVehicle,
      vehicleNumber: value,
    });
    if (value && vehicleNumberOption?.includes(value)) {
      verifyVehicle(value);
    }
  };

  const toggleWash = (service) => {
    const isCompleteWash = service.label?.toLowerCase() === "complete wash";
    const alreadySelected = currentVehicle.selectedService?.some(
      (s) => s.value === service.value
    );

    let updatedServices;
    if (isCompleteWash) {
      updatedServices = [service];
    } else {
      updatedServices =
        currentVehicle.selectedService?.filter(
          (s) => s.label?.toLowerCase() !== "complete wash"
        ) || [];
      if (alreadySelected) {
        updatedServices = updatedServices.filter(
          (s) => s.value !== service.value
        );
      } else {
        updatedServices.push(service);
      }
    }

    setCurrentVehicle((prev) => ({
      ...prev,
      selectedService: updatedServices,
    }));
  };

  const handleModelChange = (model) => {
    setCurrentVehicle((prev) => ({
      ...prev,
      selectedModel: model,
      paymentStatus: "",
      paymentMethod: "",
      partialAmount: "",
      discount: "",
      tipAmount: "",
      serviceOption: [],
      selectedService: [],
      vehicleType: "",
      model_image: null,
    }));
    if (model) {
      getVehicleTypeByModel(model);
    }
  };

  const getVehicleNumber = () => {
    getVehicleNumberApi()
      .then((res) => {
        const data = res?.data?.results?.map((item) => item?.label) || [];
        setVehicleNumberOption(data);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };

  const getBrandModel = () => {
    getBrandModelApi()
      .then((res) => {
        const apiData = res?.data?.results || [];
        const modelList = apiData.flatMap((b) =>
          b.models.map((m) => ({
            label: `${m.label} [${b.label}]`,
            value: m.value,
            brandId: b.value,
            brandLabel: b.label,
            searchLabel: `${b.label} ${m.label}`.toLowerCase(),
          }))
        );
        setModelOption(modelList);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };

  const getServices = (vehicleType) => {
    getServiceoption(vehicleType)
      .then((res) => {
        setCurrentVehicle((prev) => ({
          ...prev,
          serviceOption: res?.data?.results || [],
          selectedService:
            currentVehicle?.selectedService?.filter((service) =>
              res?.data?.results?.some((item) => item?.value == service?.value)
            ) || [],
        }));
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };

  const getVehicleTypeByModel = (model) => {
    getVehicleTypeUsingModel(model?.value || "")
      .then((res) => {
        setCurrentVehicle((prev) => ({
          ...prev,
          vehicleType: res?.data?.message?.size || "",
          model_image: res?.data?.message?.image || "",
        }));
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };

  useEffect(() => {
    getVehicleNumber();
    getBrandModel();
  }, []);

  useEffect(() => {
    if (currentVehicle.vehicleType) {
      getServices(currentVehicle.vehicleType);
    }
  }, [currentVehicle.vehicleType]);

  const createBill = (data) => {
    setCreateLoading(true);
    createBillApi(data)
      .then((res) => {
        toast.success("Bill Created successfully");
        setError({});
        // Reset form after successful creation
        setVehicles([]);
        setCurrentVehicle({
          paymentStatus: "",
          paymentMethod: "",
          partialAmount: "",
          customerName: "",
          customerMobile: "",
          selectedModel: null,
          vehicleNumber: "",
          vehicleType: "",
          isVerify: false,
          serviceOption: [],
          selectedService: [],
          discount: "",
          tipAmount: "",
          date: new Date().toISOString().split("T")[0] || "",
          is_free_service: false,
          model_image: null,
          remarks: "",
        });
        navigate("/bill");
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setCreateLoading(false);
      });
  };

  const validateCurrentVehicle = () => {
    const newError = {};
    const vehicle = currentVehicle;

    if (!vehicle.vehicleNumber.trim())
      newError.vehicleNumber = "Vehicle number is required";
    if (!vehicle.vehicleType) newError.vehicleType = "Vehicle type is required";
    if ((vehicle.selectedService || [])?.length == 0)
      newError.service = "Service type is required";

    if (!vehicle.paymentStatus)
      newError.paymentStatus = "Payment Status is required";
    if (vehicle.paymentStatus !== "UNPAID") {
      if (!vehicle.paymentMethod)
        newError.paymentMethod = "Payment method is required";
    }

    if (vehicle.paymentStatus === "PARTIALLY_PAID") {
      if (!(vehicle.partialAmount > 0))
        newError.partialAmount = "Partial amount is required";
    }

    if (!vehicle.customerName) {
      newError.customerName = "Customer name is required";
    }
    if (!vehicle?.date) {
      newError.customerName = "Date is required";
    }

    if (vehicle.customerMobile && !/^\d{10}$/.test(vehicle.customerMobile)) {
      newError.customerMobile = "Customer mobile must be 10 digits";
    }

    if (vehicle?.discount > 0) {
      if (!vehicle?.remarks) {
        newError.remarks = "Remarks required in discount case";
      }
    }

    return newError;
  };

  const handleAddVehicle = () => {
    const newError = validateCurrentVehicle();

    if (Object.keys(newError).length > 0) {
      setError(newError);
      Object.values(newError).forEach((msg) => toast.error(msg));
      return;
    }

    if (editingIndex !== null) {
      // Update existing vehicle
      const updatedVehicles = [...vehicles];
      updatedVehicles[editingIndex] = currentVehicle;
      setVehicles(updatedVehicles);
      setEditingIndex(null);
    } else {
      // Add new vehicle
      setVehicles([...vehicles, currentVehicle]);
    }

    // Reset current vehicle form
    setCurrentVehicle({
      paymentStatus: "",
      paymentMethod: "",
      partialAmount: "",
      customerName: "",
      customerMobile: "",
      selectedModel: null,
      vehicleNumber: "",
      vehicleType: "",
      isVerify: false,
      serviceOption: [],
      selectedService: [],
      discount: "",
      tipAmount: "",
      date: new Date().toISOString().split("T")[0] || "",
      is_free_service: false,
      model_image: null,
      remarks: "",
    });
  };

  const handleEditVehicle = (index) => {
    setCurrentVehicle(vehicles[index]);
    setEditingIndex(index);
  };

  const handleRemoveVehicle = (index) => {
    const updatedVehicles = [...vehicles];
    updatedVehicles.splice(index, 1);
    setVehicles(updatedVehicles);
  };

  const handleSubmit = () => {
    if (vehicles.length === 0) {
      toast.error("Please add at least one vehicle");
      return;
    }

    const payloads = vehicles.map((vehicle) => ({
      vehicle_number: vehicle.vehicleNumber.trim(),
      model_id: vehicle.selectedModel?.value || "",
      customer_name: vehicle.customerName.trim(),
      service_types: vehicle.selectedService?.map((item) => item?.value) || [],
      customer_contact: vehicle.customerMobile.trim(),
      payment_status: vehicle.paymentStatus,
      payment_method:
        vehicle.paymentStatus !== "UNPAID" ? vehicle?.paymentMethod : "",
      partial_amount:
        vehicle.paymentStatus === "PARTIALLY_PAID"
          ? vehicle?.partialAmount
          : "",
      discount: vehicle.discount || "0",
      remark: vehicle?.discount > 0 ? vehicle?.remarks : "",
      tips: vehicle.tipAmount || "",
      date: vehicle?.date || "",
      is_free_service: vehicle?.is_free_service,
      // Only include vehicle_type if no model_id is provided
      ...(!vehicle.selectedModel?.value && {
        vehicle_type: vehicle?.vehicleType || "",
      }),
    }));

    createBill(payloads);
  };

  const totalAmount = (vehicle) => {
    const totalServiceAmount = vehicle.selectedService?.reduce(
      (sum, s) => sum + Number(s.price || 0),
      0
    );
    return Math.max(totalServiceAmount, 0);
  };
  const calculateVehicleTotal = (vehicle) => {
    const totalServiceAmount = vehicle.selectedService?.reduce(
      (sum, s) => sum + Number(s.price || 0),
      0
    );
    return Math.max(
      totalServiceAmount +
        Number(vehicle?.tipAmount || 0) -
        Number(vehicle.discount || 0),
      0
    );
  };

  const handleCancel = () => {
    setEditingIndex(null);
    setCurrentVehicle({
      paymentStatus: "",
      paymentMethod: "",
      partialAmount: "",
      customerName: "",
      customerMobile: "",
      selectedBrand: null,
      selectedModel: null,
      vehicleNumber: "",
      vehicleType: "",
      isVerify: false,
      serviceOption: [],
      selectedService: [],
      discount: "",
      tipAmount: "",
      date: new Date().toISOString().split("T")[0] || "",
      is_free_service: false,
      model_image: null,
      remarks: "",
    });
  };

  return (
    <div className="container-fluid mt-2 p-0">
      <div className="row g-2">
        {/* Left Side: Billing Form */}
        <div className="col-md-8">
          <div className="card mb-4 shadow-sm">
            <div className="card-body">
              <div className="d-flex gap-1 mb-2">
                <Link
                  to="/bill"
                  className="btn btn-outline-light rounded-2 p-2"
                >
                  <FaArrowLeft className="text-dark" />
                </Link>
                <div className="d-flex flex-column">
                  <h5 className="mb-0">
                    Vehicle Information{" "}
                    {editingIndex !== null &&
                      `(Editing Vehicle ${editingIndex + 1})`}
                  </h5>
                  <span
                    className="fw-medium text-dark"
                    style={{ fontSize: "0.7rem" }}
                  >
                    (Fill all the required fields)
                  </span>
                </div>
              </div>

              <div className="row mb-3 gy-2">
                <div className="col-md-4">
                  <label className="form-label text-dark mb-1">
                    Vehicle Number <span className="text-danger">*</span>
                  </label>
                  <div className="position-relative">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="e.g., DL01AB1234"
                      list="vehicleSuggestions"
                      value={currentVehicle.vehicleNumber}
                      onChange={(e) => {
                        const value = e.target.value
                          .replace(/[^a-zA-Z0-9]/g, "")
                          .toUpperCase();
                        handleChangVehicleNumber(value);
                      }}
                      // onBlur={
                      //   vehicleNumberOption?.includes(
                      //     currentVehicle?.vehicleNumber
                      //   )
                      //     ? () => verifyVehicle()
                      //     : undefined
                      // }
                    />
                    {currentVehicle?.verifyLoading ? (
                      <button
                        type="button"
                        style={{
                          right: "5px",
                          padding: "0.45rem",
                        }}
                        className={`btn btn-sm rounded-2 btn-light position-absolute top-50 translate-middle-y text-secondary icon-float`}
                      >
                        <Spinner animation="border" size="sm" />
                      </button>
                    ) : currentVehicle?.isVerify ? (
                      <button
                        type="button"
                        style={{
                          right: "5px",
                          padding: "0.45rem",
                        }}
                        className={`btn btn-sm rounded-2 btn-success position-absolute top-50 translate-middle-y text-secondary icon-float`}
                      >
                        <FaRegCheckCircle className="text-white" size={15} />
                      </button>
                    ) : currentVehicle?.vehicleNumber ? (
                      <button
                        type="button"
                        style={{
                          right: "5px",
                          padding: "0.45rem",
                        }}
                        className={`btn btn-sm rounded-2 text-bg-primary-soft position-absolute top-50 translate-middle-y text-secondary`}
                      >
                        <MdRunningWithErrors
                          className="text-primary"
                          size={16}
                        />
                      </button>
                    ) : (
                      ""
                    )}

                    {currentVehicle?.vehicleNumber && (
                      <datalist id="vehicleSuggestions">
                        {vehicleNumberOption
                          ?.filter((num) =>
                            num
                              ?.toLowerCase()
                              ?.includes(
                                currentVehicle?.vehicleNumber?.toLowerCase()
                              )
                          )
                          ?.slice(0, 10)
                          ?.map((num) => (
                            <option key={num} value={num} />
                          ))}
                      </datalist>
                    )}
                  </div>
                </div>
                <div className="col-md-4">
                  <label className="form-label text-dark mb-1">Model</label>{" "}
                  <span className="text-danger">*</span>
                  <Select
                    placeholder="Select Model"
                    classNamePrefix="select"
                    className="react-select"
                    options={modelOption}
                    value={currentVehicle.selectedModel}
                    onChange={(model) => handleModelChange(model)}
                    isClearable
                    isSearchable
                    filterOption={(option, input) =>
                      option.data.searchLabel.includes(input.toLowerCase())
                    }
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label text-dark mb-1">
                    Customer Name
                  </label>{" "}
                  <span className="text-danger">*</span>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="John Deo"
                    value={currentVehicle.customerName}
                    onChange={(e) =>
                      setCurrentVehicle((prev) => ({
                        ...prev,
                        customerName: e.target.value || "",
                      }))
                    }
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label text-dark mb-1">
                    WhatsApp Number
                  </label>{" "}
                  <span className="text-danger">*</span>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="9777303064"
                    value={currentVehicle.customerMobile}
                    onChange={(e) => {
                      const rawValue = e.target.value;
                      const cleanedValue = rawValue.replace(/\s+/g, "");
                      if (/^\d*$/.test(cleanedValue)) {
                        setCurrentVehicle((prev) => ({
                          ...prev,
                          customerMobile: cleanedValue || "",
                        }));
                      }
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label text-dark mb-1">
                    Billing Date
                  </label>{" "}
                  <span className="text-danger">*</span>
                  <input
                    className="form-control"
                    type="date"
                    value={currentVehicle.date}
                    onChange={(e) => {
                      const value = e.target.value;

                      setCurrentVehicle((prev) => ({
                        ...prev,
                        date: value || "",
                      }));
                    }}
                    max={new Date().toISOString().split("T")[0]}
                  />
                </div>
                {currentVehicle?.vehicleType && (
                  <div className="col-md-4">
                    <div className="d-inline-block">
                      <label
                        className="form-label text-dark fw-medium mb-1"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Vehicle Type:
                      </label>
                      <VehicleTypeBadge
                        vehicleType={currentVehicle?.vehicleType || "Small Car"}
                        image={currentVehicle?.model_image}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {currentVehicle.serviceOption?.length > 0 && (
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="mb-1">
                  <FaTags className="me-2" />
                  Service Information
                </h5>
                <div className="form-check mt-2">
                  <input
                    type="checkbox"
                    id="isFreeService"
                    className="form-check-input"
                    checked={currentVehicle.is_free_service}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      if (isChecked) {
                        setServiceConfirmation(true);
                      } else {
                        setCurrentVehicle((prev) => ({
                          ...prev,
                          paymentStatus: "",
                          is_free_service: false,
                        }));
                      }
                    }}
                  />
                  <label htmlFor="isFreeService" className="form-check-label">
                    Free Service
                  </label>
                </div>
                <label
                  className="text-dark fw-medium mt-2"
                  style={{ fontSize: "0.8rem" }}
                >
                  Service Type
                </label>{" "}
                <span className="text-danger">*</span>
                <div className="d-flex gap-3 flex-wrap mb-2 mt-1">
                  {currentVehicle.serviceOption?.length === 0
                    ? Array.from({ length: 3 }).map((_, index) => (
                        <Skeleton
                          key={index}
                          variant="rectangular"
                          width={100}
                          height={60}
                          animation="wave"
                          className="rounded-2"
                        />
                      ))
                    : currentVehicle.serviceOption.map((option) => {
                        const isSelected = currentVehicle.selectedService?.some(
                          (s) => s.value == option.value
                        );

                        return (
                          <div
                            key={option.value}
                            onClick={() => toggleWash(option)}
                            className={`position-relative border rounded-3 p-2 pe-3 text-center cursor-pointer ${
                              isSelected
                                ? "bg-primary text-white shadow border-primary"
                                : "bg-lighter shadow-sm border-secondary"
                            }`}
                            style={{
                              transition: "all 0.25s ease",
                            }}
                          >
                            {isSelected && (
                              <FaCheckCircle
                                className="position-absolute"
                                style={{
                                  top: "3px",
                                  right: "3px",
                                  fontSize: "0.9rem",
                                  color: "#fff",
                                }}
                              />
                            )}

                            <div
                              className="fw-semibold"
                              style={{ fontSize: "0.8rem" }}
                            >
                              {option.label}
                            </div>
                            <p
                              className="mb-0 fw-medium"
                              style={{ fontSize: "0.75rem" }}
                            >
                              ₹{option.price}
                            </p>
                          </div>
                        );
                      })}
                </div>
                {!currentVehicle?.is_free_service && (
                  <>
                    <div className="d-flex justify-content-between align-items-center gap-3 border-top mt-3 pt-2 flex-wrap">
                      <div className="d-flex gap-2">
                        <div>
                          <label
                            className="form-label text-dark mb-0"
                            style={{ fontSize: "0.8rem" }}
                          >
                            Discount
                          </label>
                          <div className="position-relative">
                            <input
                              type="text"
                              placeholder="optional"
                              className="form-control"
                              value={currentVehicle.discount}
                              onChange={(e) => {
                                let value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                  const total = totalAmount(currentVehicle);

                                  let numericValue = Number(value);
                                  if (numericValue > total) {
                                    numericValue = 0;
                                  }

                                  setCurrentVehicle((prev) => ({
                                    ...prev,
                                    discount: numericValue.toString(),
                                  }));
                                }
                              }}
                            />
                            <BiSolidDiscount
                              className="position-absolute top-50 translate-middle-y text-primary"
                              style={{ right: "15px", pointerEvents: "none" }}
                            />
                          </div>
                        </div>
                        <div>
                          <label
                            className="form-label text-dark mb-0"
                            style={{ fontSize: "0.8rem" }}
                          >
                            Tips
                          </label>
                          <div className="position-relative">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="optional"
                              value={currentVehicle.tipAmount}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                  setCurrentVehicle((prev) => ({
                                    ...prev,
                                    tipAmount: value,
                                    partialAmount: "0",
                                  }));
                                }
                              }}
                            />
                            <RiMoneyRupeeCircleFill
                              className="position-absolute top-50 translate-middle-y text-primary"
                              style={{ right: "15px", pointerEvents: "none" }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="fw-medium d-flex flex-column">
                        <span
                          className="form-label text-dark mb-0"
                          style={{ fontSize: "0.8rem" }}
                        >
                          Total Amount
                        </span>
                        <span className="text-darker">
                          ₹
                          {currentVehicle.selectedService?.length > 0
                            ? calculateVehicleTotal(currentVehicle)
                            : 0}
                        </span>
                      </div>
                    </div>
                    {currentVehicle?.discount > 0 && (
                      <div className="mt-2">
                        <label
                          className="form-label text-dark mb-1"
                          style={{ fontSize: "0.85rem" }}
                        >
                          Remarks for discount
                        </label>{" "}
                        <span className="text-danger">*</span>
                        <textarea
                          name="remarks"
                          className="form-control"
                          rows={1}
                          placeholder="e.g. Repeat visit within 30 days—retention benefit."
                          value={currentVehicle?.remarks || ""}
                          onChange={(e) => {
                            setCurrentVehicle({
                              ...currentVehicle,
                              remarks: e.target?.value || "",
                            });
                          }}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          )}

          {!currentVehicle?.is_free_service &&
            currentVehicle?.selectedService?.length > 0 && (
              <>
                <div className="card p-3 shadow-sm">
                  <h6 className="mb-3 text-dark">
                    <FaWallet className="me-2" />
                    Payment Information
                  </h6>

                  {/* Payment Status */}
                  <div className="mb-3">
                    <label className="form-label text-dark small mb-1">
                      Payment Status
                    </label>{" "}
                    <span className="text-danger">*</span>
                    <div className="d-flex gap-2 flex-wrap">
                      {[
                        { label: "Paid", value: "PAID" },
                        { label: "Unpaid", value: "UNPAID" },
                        { label: "Partially paid", value: "PARTIALLY_PAID" },
                      ].map((status) => {
                        const iconMap = {
                          PAID: <FaCheckCircle className="me-1" />,
                          UNPAID: <FaTimesCircle className="me-1" />,
                          PARTIALLY_PAID: <FaAdjust className="me-1" />,
                        };

                        return (
                          <div
                            key={status?.value}
                            className={`px-2 py-1 rounded-3 border small fw-medium d-flex align-items-center justify-content-center cursor-pointer ${
                              currentVehicle.paymentStatus === status?.value
                                ? "bg-primary text-white"
                                : "bg-light text-secondary"
                            }`}
                            onClick={() => {
                              setCurrentVehicle((prev) => ({
                                ...prev,
                                paymentStatus: status?.value,
                                paymentMethod:
                                  status?.value === "UNPAID"
                                    ? ""
                                    : prev.paymentMethod,
                                partialAmount:
                                  status?.value === "UNPAID"
                                    ? ""
                                    : prev.partialAmount,
                                ...(status?.value === "UNPAID"
                                  ? { tipAmount: 0 }
                                  : {}),
                              }));
                            }}
                          >
                            {iconMap[status?.value]}
                            {status?.label}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Payment Method – for Paid or Partial */}
                  {(currentVehicle.paymentStatus === "PAID" ||
                    currentVehicle.paymentStatus === "PARTIALLY_PAID") && (
                    <div className="mb-3">
                      <label className="form-label text-dark small mb-1">
                        Payment Method
                      </label>{" "}
                      <span className="text-danger">*</span>
                      <div className="d-flex gap-2 flex-wrap">
                        {paymentTypes.map(({ key, label, icon }) => (
                          <div
                            key={key}
                            className={`px-2 py-1 rounded-3 border d-inline-flex align-items-center gap-1 cursor-pointer small fw-medium ${
                              currentVehicle.paymentMethod === key
                                ? "bg-primary text-white"
                                : "bg-light text-secondary"
                            }`}
                            onClick={() =>
                              setCurrentVehicle((prev) => ({
                                ...prev,
                                paymentMethod: key,
                                ...(key === "CASH" ? { tipAmount: 0 } : {}),
                              }))
                            }
                          >
                            {icon}
                            <span>{label}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Partial Amount Input – only if Partial */}
                  {currentVehicle.paymentStatus === "PARTIALLY_PAID" && (
                    <div className="col-md-6 mb-1">
                      <label className="form-label text-dark small mb-1">
                        Partial Payment Amount
                      </label>{" "}
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control form-control"
                        placeholder="Enter amount paid"
                        value={currentVehicle.partialAmount}
                        autoFocus
                        onChange={(e) => {
                          let value = e.target.value;
                          if (/^\d*$/.test(value)) {
                            const total = calculateVehicleTotal(currentVehicle);
                            let numericValue = Number(value);
                            if (numericValue >= total) {
                              numericValue = 0;
                            }

                            setCurrentVehicle((prev) => ({
                              ...prev,
                              partialAmount: numericValue.toString(),
                            }));
                          }
                        }}
                      />
                    </div>
                  )}
                </div>
              </>
            )}

          <div className="mt-2 d-flex justify-content-end gap-2">
            {editingIndex != null && (
              <button
                className="btn btn-outline-secondary"
                onClick={handleCancel}
              >
                Cancel
              </button>
            )}

            <button
              className="btn btn-primary"
              onClick={handleAddVehicle}
              disabled={
                !currentVehicle.vehicleNumber ||
                !currentVehicle.vehicleType ||
                currentVehicle.selectedService?.length === 0
              }
            >
              {editingIndex !== null ? (
                "Update Vehicle"
              ) : (
                <>
                  {/* <MdAdd className="me-1" size="20" /> */}
                  Add Vehicle
                </>
              )}
            </button>
          </div>
        </div>

        {/* Right Side: Billing Summary */}
        <Col md={4}>
          <Card className="shadow-sm position-sticky" style={{ top: "5rem" }}>
            <Card.Body>
              <div className="d-flex justify-content-between">
                <div>
                  <h5 className="mb-3">
                    <FaCar className="me-2" />
                    Vehicles
                  </h5>
                </div>
                <div
                  className="text-dark fw-medium"
                  style={{ fontSize: "0.75rem" }}
                >
                  Total: ({vehicles.length})
                </div>
              </div>

              {vehicles.length === 0 ? (
                <div className="py-2 text-center bg-light">
                  <span className="fw-medium text-dark">No Vehicle Added</span>
                </div>
              ) : (
                <div
                  className="mb-3 scroll-container"
                  style={{ maxHeight: "300px", overflowY: "auto" }}
                >
                  {vehicles.map((vehicle, index) => (
                    <Card key={index} className="mb-2 rounded-3">
                      <Card.Body className="p-2">
                        <div className="d-flex justify-content-between">
                          <div>
                            <div className="fw-medium">
                              {vehicle.vehicleNumber}
                              {vehicle?.is_free_service && (
                                <span
                                  className="text-danger fw-medium ms-1"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  (Free)
                                </span>
                              )}
                            </div>
                            <div
                              className="small text-small"
                              style={{ fontSize: "0.8rem" }}
                            >
                              {vehicle.selectedService
                                ?.map((s) => s.label)
                                .join(", ")}
                            </div>
                            <div className="fw-bold">
                              ₹{calculateVehicleTotal(vehicle)}
                            </div>
                          </div>
                          <div className="d-flex gap-1 align-self-start">
                            <span
                              className="p-1 btn btn-outline-light ms-1"
                              onClick={() => handleEditVehicle(index)}
                            >
                              <FiEdit2 className="text-dark" />
                            </span>
                            <span
                              className="p-1 btn btn-outline-light ms-1"
                              onClick={() => handleRemoveVehicle(index)}
                            >
                              <FiTrash2 className="text-dark" />
                            </span>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  ))}
                </div>
              )}

              <div className="mt-3 border-top pt-3">
                <h5 className="mb-3">🧾 Billing Summary</h5>

                {/* Services Breakdown */}
                <div className="mb-3 small text-dark">
                  {vehicles.length > 0 ? (
                    <>
                      {vehicles.flatMap((vehicle, vIndex) =>
                        vehicle.selectedService?.map((service, sIndex) => (
                          <div
                            key={`${vIndex}-${sIndex}`}
                            className={`d-flex justify-content-between mb-1 ${
                              vehicle.is_free_service
                                ? "text-danger line-through"
                                : ""
                            }`}
                            style={
                              vehicle.is_free_service
                                ? { position: "relative" }
                                : {}
                            }
                          >
                            <span>
                              {vehicle.vehicleNumber} - {service.label}
                            </span>
                            <span>
                              ₹{service.price}
                              {vehicle.is_free_service && (
                                <span
                                  style={{
                                    position: "absolute",
                                    left: 0,
                                    right: 0,
                                    top: "50%",
                                    borderTop: "1px solid red",
                                    transform: "translateY(-50%)",
                                    zIndex: 1,
                                  }}
                                />
                              )}
                            </span>
                          </div>
                        ))
                      )}

                      <hr />
                      <div className="d-flex justify-content-between fw-bold mb-1">
                        <span>Subtotal</span>
                        <span>
                          ₹
                          {vehicles.reduce((total, vehicle) => {
                            if (vehicle.is_free_service) return total;
                            const vehicleTotal =
                              vehicle.selectedService?.reduce(
                                (sum, service) =>
                                  sum + Number(service.price || 0),
                                0
                              ) || 0;
                            return total + vehicleTotal;
                          }, 0)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between text-danger mb-1 fw-normal">
                        <span>Total Discount</span>
                        <span>
                          - ₹
                          {vehicles.reduce(
                            (sum, vehicle) =>
                              sum + Number(vehicle.discount || 0),
                            0
                          )}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between mb-1 fw-normal">
                        <span>Total Tips</span>
                        <span>
                          +₹
                          {vehicles.reduce(
                            (sum, vehicle) =>
                              sum + Number(vehicle?.tipAmount || 0),
                            0
                          )}
                        </span>
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between fw-bold text-dark mb-3">
                        <span>Total Amount</span>
                        <span>
                          ₹
                          {vehicles.reduce(
                            (total, vehicle) =>
                              total +
                              (vehicle?.is_free_service
                                ? 0
                                : calculateVehicleTotal(vehicle)),
                            0
                          )}
                        </span>
                      </div>
                    </>
                  ) : (
                    <div className="text-muted text-center">
                      No vehicles added
                    </div>
                  )}
                </div>

                {/* Action Button */}
                <button
                  variant=""
                  className="btn btn-primary w-100"
                  onClick={handleSubmit}
                  disabled={vehicles.length === 0 || createLoading}
                >
                  {createLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Generate Bill"
                  )}
                </button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </div>

      <Dialog
        open={overrideDialogOpen}
        onClose={() => setOverrideDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle className="d-flex justify-content-between align-items-center p-2">
          <span className="d-flex">
            <FaCar className="me-2" />
            <h5>Vehicle Information Found</h5>
          </span>
          <IconButton size="small" onClick={() => setOverrideDialogOpen(false)}>
            <MdOutlineClose className="text-dark" />
          </IconButton>
        </DialogTitle>

        <Divider />

        <DialogContent sx={{ mt: 0 }}>
          <p className="text-darker small mb-3">
            The system has found existing details for this vehicle. Choose which
            information you’d like to update:
          </p>

          <div className="card border rounded bg-lighter p-3">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="selectAll"
                checked={Object.values(selectedOverrides).every((v) => v)}
                ref={(input) => {
                  if (input) {
                    input.indeterminate =
                      !Object.values(selectedOverrides).every((v) => v) &&
                      Object.values(selectedOverrides).some((v) => v);
                  }
                }}
                onChange={(e) => handleSelectAll(e.target.checked)}
              />
              <label className="form-check-label fw-bold" htmlFor="selectAll">
                Select All Fields
              </label>
            </div>

            <hr />

            {/* Individual Fields with Comparison */}
            {["customerName", "customerMobile", "selectedModel"].map(
              (field) => {
                const fieldLabels = {
                  customerName: "Customer Name",
                  customerMobile: "Customer Mobile",
                  selectedModel: "Vehicle Model",
                  // vehicleType: "Vehicle Type",
                  // model_image: "Model Image",
                };

                const label = fieldLabels[field] || field;
                //  const{oldValue,newValue}=overrideFields[field]||{}
                const isModelField = field == "selectedModel";
                return (
                  <>
                    <div
                      key={field}
                      className="form-check mb-0 mt-2 d-flex align-items-start"
                    >
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={field}
                        checked={selectedOverrides[field] || false}
                        onChange={() => handleCheckboxChange(field)}
                      />
                      <label className="form-check-label" htmlFor={field}>
                        <div className="fw-semibold">{label}</div>
                      </label>
                    </div>
                    <div
                      className="text-darker d-flex flex-wrap align-items-center gap-1"
                      style={{ fontSize: "0.85rem", marginLeft: "32px" }}
                    >
                      <span>
                        You:{" "}
                        <span className="fw-medium">
                          {isModelField
                            ? currentVehicle?.[field]?.label || "Not Available"
                            : currentVehicle?.[field] || "Not Available"}
                        </span>
                      </span>
                      <FaArrowRight className="text-secondary" size={12} />
                      <span>
                        System:{" "}
                        <span className="fw-medium">
                          {isModelField
                            ? overrideFields?.[field]?.label
                            : overrideFields?.[field] ?? "Not Available"}
                        </span>
                      </span>
                    </div>
                  </>
                );
              }
            )}
          </div>
        </DialogContent>

        <Divider />

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={() => setOverrideDialogOpen(false)}
            variant="outlined"
            color="inherit"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleOverrideConfirm}
          >
            Apply Updates
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={serviceConfirmation}
        onClose={handleCancelFreeService}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3 },
        }}
      >
        <DialogTitle className="d-flex justify-content-end align-items-center p-0 pt-1 px-2">
          {/* <span className="fw-medium fs-5 text-primary">
            Confirm Free Service
          </span> */}
          <IconButton onClick={handleCancelFreeService} size="small">
            <MdOutlineClose className="text-dark" />
          </IconButton>
        </DialogTitle>

        <div className="text-center my-3">
          <FaRegQuestionCircle size={48} className="text-warning mb-2" />
          <p className="mb-0 fs-6">
            Are you sure you want to mark this as a <b>Free Service</b>?<br />
            This will reset all payment fields.
          </p>
        </div>

        <DialogActions className="justify-content-center border-top py-3">
          <Button
            variant="outlined"
            color="inherit"
            onClick={handleCancelFreeService}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleConfirmFreeService}
          >
            Yes, Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BillingAdd;
